import { z } from 'zod'

import { commonSchema } from './commonSchema'

export const addSchema = commonSchema

export type AddSchema = z.infer<typeof commonSchema>

export const addSchemaDefault: AddSchema = {
  adUnitIds: { left: [], right: [] },
  customVariableName: '',
  customVariableTriggerEnabled: false,
  customVariableValue: '',
  domainId: '',
  matchType: 'include',
  name: '',
  onlySendAdRequestsForAssignedAdUnits: false,
  path: '',
  pathTriggerEnabled: false,
}
